import FormHelperText from "@mui/material/FormHelperText";

//TODO: Don't have styles for this yet, update when needed
function FormFieldWarning({ id, text }) {
  return (
    <FormHelperText
      sx={{ marginLeft: 0, color: "#ffa726" }}
      id={id + "-warning"}>
      {text}
    </FormHelperText>
  );
}

export default FormFieldWarning;
